import { actionTypes } from '../types/actionTypes'
import {
  ICheckbox,
  IDatesValue,
  ISearchWorkOrder,
  ReducerOtInboundDifference
} from '../types/reducerTypes'

export const searchInitialState: ISearchWorkOrder = {
  searchField: '',
  searchValue: '',
  searchFieldSecondary: '',
  searchValueSecondary: ''
}

export const datesValueInitalState: IDatesValue = {
  InitialReceivedDate: '',
  FinalReceivedDate: ''
}

export const checkboxInitalState: ICheckbox[] = [
  // { name: 'Declarar Merma', isChecked: false, isDisabled: false },
  { name: 'Declarar Sobrante', isChecked: false, isDisabled: false },
  { name: 'Declarar Faltante', isChecked: false, isDisabled: false }
]
/*

Copyright 2022-04-26 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agrega estado isShowInboundAdjust para manejar aparicion del modal

Copyright 2022-04-27 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agrega estado para showSkuOrName, de modo que el sistema pueda decidir
si debe mostrar sku o nombre. Igualmente se agrega case para accion del reducer. 
Igualmente se añade la funcionalidad para indicar cual es la orden de trabajo que esta seleccionada y 
el estado correspondiente a los items del ajuste de la asn.

Copyright 2022-05-05 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agrega estado para apertura y cierre de modal DeclareError desde reducer/context.


Copyright 2022-05-10 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agrega estado para ConfirmRelease (modal confirmación liberación de ASN)


Copyright 2022-05-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se añade estado para loading de release asn
*/

export const initialState: ReducerOtInboundDifference = {
  isLoading: false,
  suppliers: [],
  rows: [],
  supplierId: 0,
  sorters: [],
  page: 0,
  totalItems: 0,
  rowsPerPage: 5,
  busqueda: searchInitialState,
  filters: [],
  isRangeDate: false,
  datesValue: datesValueInitalState,
  checkboxItems: [],
  isShowInboundAdjustModal: false,
  adjustAsnWorkOrderItems: [],
  selectedOT: 0,
  workOrderInboundSkuAdjust: [],
  showSkuOrName: false,
  skuAdjustItems: [],
  skuUpdateAdjust: null,
  isShowDeclareErrorModal: false,
  isOpenConfirmReleaseASN: false,
  isLoadingModal: false,
  userId: 0,
  notifyStatus: {
    isOpen: false,
    message: '',
    status: 'success'
  },
  asnToRelease: { asnId: 0, workOrderId: 0, asnNumber: '' },
  isLoadingReleaseAsn: false
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const otInboundDifferenceReducer = (
  state: ReducerOtInboundDifference,
  action: actionTypes
) => {
  switch (action.type) {
    case 'setIsRangeDate':
      return {
        ...state,
        isRangeDate: action.payload
      }
    case 'setIsLoading':
      return {
        ...state,
        isLoading: action.payload
      }
    case 'setIsLoadingModal':
      return {
        ...state,
        isLoadingModal: action.payload
      }
    case 'setSuppliers':
      return {
        ...state,
        suppliers: action.payload
      }
    case 'setRows':
      return {
        ...state,
        rows: action.payload
      }
    case 'setSupplierId':
      return {
        ...state,
        supplierId: action.payload
      }
    case 'setSorters':
      return {
        ...state,
        sorters: action.payload
      }
    case 'setPage':
      return {
        ...state,
        page: action.payload
      }
    case 'setTotalItems':
      return {
        ...state,
        totalItems: action.payload
      }
    case 'setRowsPerPage':
      return {
        ...state,
        rowsPerPage: action.payload
      }
    case 'setSearchField':
      return {
        ...state,
        busqueda: { ...state.busqueda, searchField: action.payload }
      }
    case 'setResetSearchField':
      return {
        ...state,
        busqueda: { ...state.busqueda, searchField: '' }
      }
    case 'setSearchValue':
      return {
        ...state,
        busqueda: { ...state.busqueda, searchValue: action.payload }
      }
    case 'setResetSearchValue':
      return {
        ...state,
        busqueda: { ...state.busqueda, searchValue: '' }
      }
    case 'setBusqueda':
      return {
        ...state,
        busqueda: action.payload
      }
    case 'setResetBusqueda':
      return {
        ...state,
        busqueda: searchInitialState
      }
    case 'setFilters':
      return {
        ...state,
        filters: action.payload
      }
    case 'SetDatesValue':
      return {
        ...state,
        datesValue: action.payload
      }
    case 'setCheckboxItems':
      return {
        ...state,
        checkboxItems: action.payload
      }

    case 'setShowInboundAdjustModal':
      return {
        ...state,
        isShowInboundAdjustModal: action.payload
      }
    case 'setInboundAdjustItems':
      return {
        ...state,
        adjustAsnWorkOrderItems: action.payload
      }
    case 'setSelectedOT': {
      return {
        ...state,
        selectedOT: action.payload
      }
    }

    case 'setWorkOrderInboundSkuAdjust': {
      return {
        ...state,
        workOrderInboundSkuAdjust: action.payload
      }
    }
    case 'setShowSkuOrName': {
      return {
        ...state,
        showSkuOrName: action.payload
      }
    }
    case 'setSkuAdjustItems': {
      return {
        ...state,
        skuAdjustItems: action.payload
      }
    }

    case 'setSkuUpdateAdjust': {
      return {
        ...state,
        skuUpdateAdjust: action.payload
      }
    }
    case 'setShowDeclareErrorModal': {
      return {
        ...state,
        isShowDeclareErrorModal: action.payload
      }
    }
    case 'setIsOpenConfirmReleaseASN': {
      return {
        ...state,
        isOpenConfirmReleaseASN: action.payload
      }
    }
    case 'setUser': {
      return {
        ...state,
        userId: action.payload
      }
    }
    case 'setNotifyStatus': {
      return {
        ...state,
        notifyStatus: action.payload
      }
    }
    case 'setAsnToRelease': {
      return {
        ...state,
        asnToRelease: action.payload
      }
    }
    case 'setLoadingReleaseASN': {
      return {
        ...state,
        isLoadingReleaseAsn: action.payload
      }
    }
    default:
      return state
  }
}
